import type { EffectParams } from '@swf/core/store';

const fetchPrizeGameVersion = async (payload: undefined, { dispatch, request }: EffectParams) => {
  const { body } = await request({
    service: 'casino.prizegame.tclatestversion'
  });
  await dispatch.casino.set({
    sotdLatestVersion: body
  });
};

export default fetchPrizeGameVersion;
